import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import Search, { type SearchActionProps, type SearchMapProps } from "@client/widgets/Header/Search/component";
import { search, setSearchBarVisible } from "../actions";
import { isSearchBarVisibleSelector } from "../selectors";

const mapStateToProps = (state: AppState): SearchMapProps => {
  const isVisible = isSearchBarVisibleSelector(state);
  return {
    isVisible
  };
};

const mapDispatchToProps = (dispatch): SearchActionProps => ({
  close: () => dispatch(setSearchBarVisible(false)),
  onSearch: (text: string) => dispatch(search(text))
});

export default connectCustom(mapStateToProps, mapDispatchToProps)(Search);
